import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import React from 'react'
import { CheckboxProps, Input } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { Values } from './FormContext'
import YesNo from 'src/components/Forms/YesNo'
import Checkboxes from 'src/components/Forms/Checkboxes'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
  holidays?: CheckboxProps[]
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave, holidays = [] } = props
  const { handleSubmit } = useFormikContext<Values>()
  return (
    <>
      <Body error={{
        error: 'There was an issue updating the staffing agency benefits.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='staffingAgency.benefits.payrollRunTime' label='Payroll Run Time' />
        <YesNo name='staffingAgency.benefits.healthBenefits' label='Health Benefits' />
        <Input type='text' name='staffingAgency.benefits.pto' label='PTO' />
        <Checkboxes
          label='Holidays'
          options={holidays}
        />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
